
function dataIsAlive(data) {
  if(data == undefined || data == null || Object.is(data, NaN))
    return false;
  return true;
}

//数据有值 非空情况下判断字符串是否为空
function dataIsValuable(data) {
  if(data == "")
    return false;
  return true;
}

function dataIsValue(data) {
  if(dataIsAlive(data) && dataIsValuable(data))
    return true;
  return false;
}

function dataListIsValue(...data) {
  for(var i = 0 ; i < data.length ; i ++) {
    if(!dataIsValue(data[i]))
      return false;
  }
  return true;
}

function formatDate(date, formatString = undefined) {
  date = new Date(date)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  if(formatString != undefined) {
    return `${year}${formatString}${month}${formatString}${day}`;
  }
  return `${year}年${month}月${day}日`;
}

function formatDateTime(date, formatString = undefined) {
  date = new Date(date)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  if(hour < 10) {
    hour = "0" + hour;
  }
  if(minute < 10) {
    minute = "0" + minute;
  }
  if(second < 10) {
    second = "0" + second;
  }
  if(formatString != undefined) {
    return `${year}${formatString}${month}${formatString}${day} ${hour}:${minute}:${second}`;
  }
  return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
}

function formatTime(date) {
  date = new Date(date)
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  if(hour < 10) {
    hour = "0" + hour;
  }
  if(minute < 10) {
    minute = "0" + minute;
  }
  if(second < 10) {
    second = "0" + second;
  }
  return `${hour}:${minute}:${second}`;
}

export default {
  dataIsAlive,
  dataIsValuable,
  dataIsValue,
  dataListIsValue,
  formatDate,
  formatDateTime,
  formatTime,
}